import {
  AlbumSummary,
  ChallengeRecord,
  ChallengeRecordListField,
  GameRecord,
  GameRecordListField,
  RecordStoreState,
  RevisionSchedule,
  RevisionScheduleListField,
} from '../../models/RecordStore';
import { Cursor } from '../../models/Repository';
import { SpaceSummary } from '../../models/SpaceStore';

export const getGameRecords = (
  state: RecordStoreState,
  fieldName: GameRecordListField,
) => state.gameRecords.list(fieldName).get();

export const getGameRecord = (state: RecordStoreState, gameRecordId: string) =>
  state.gameRecords.get(gameRecordId);

export const setGameRecords = (
  state: RecordStoreState,
  fieldName: GameRecordListField,
  ...gameRecords: GameRecord[]
) => {
  state.gameRecords.list(fieldName).set(...gameRecords);
};

export const pushGameRecords = (
  state: RecordStoreState,
  fieldName: GameRecordListField,
  ...gameRecords: GameRecord[]
) => {
  state.gameRecords.list(fieldName).push(...gameRecords);
};

export const setGameRecordCursor = (
  state: RecordStoreState,
  fieldName: GameRecordListField,
  cursor: Cursor,
) => {
  state.gameRecords.list(fieldName).setCursor(cursor);
};

export const getChallengeRecords = (
  state: RecordStoreState,
  fieldName: ChallengeRecordListField,
) => state.challengeRecords.list(fieldName).get();

export const getChallengeRecord = (
  state: RecordStoreState,
  challengeRecordId: string,
) => state.challengeRecords.get(challengeRecordId);

export const setChallengeRecords = (
  state: RecordStoreState,
  fieldName: ChallengeRecordListField,
  ...challengeRecords: ChallengeRecord[]
) => {
  state.challengeRecords.list(fieldName).set(...challengeRecords);
};

export const pushChallengeRecords = (
  state: RecordStoreState,
  fieldName: ChallengeRecordListField,
  ...challengeRecords: ChallengeRecord[]
) => {
  state.challengeRecords.list(fieldName).push(...challengeRecords);
};

export const setChallengeRecordCursor = (
  state: RecordStoreState,
  fieldName: ChallengeRecordListField,
  cursor: Cursor,
) => {
  state.challengeRecords.list(fieldName).setCursor(cursor);
};

export const getAlbumSummary = (
  state: RecordStoreState,
  gameSetId: string,
  userId: string,
) => state.albumSummaries.get(`${gameSetId}_${userId}`);

export const addAlbumSummaryToMap = (
  state: RecordStoreState,
  gameSetId: string,
  albumSummary: AlbumSummary,
) =>
  state.albumSummaries.map(`album_${gameSetId}`).set(gameSetId, albumSummary);

export const getSpaceSummary = (state: RecordStoreState, classroomId: string) =>
  state.spaceSummaries.get(classroomId);

export const addSpaceSummaryToMap = (
  state: RecordStoreState,
  classroomId: string,
  spaceSummary: SpaceSummary,
) =>
  state.spaceSummaries
    .map(`classroom_${classroomId}`)
    .set(classroomId, spaceSummary);

export const getRevisionSchedules = (
  state: RecordStoreState,
  fieldName: RevisionScheduleListField,
) => state.revisionSchedules.list(fieldName).get();

export const getRevisionSchedule = (
  state: RecordStoreState,
  revisionScheduleId: string,
) => state.revisionSchedules.get(revisionScheduleId);

export const setRevisionSchedules = (
  state: RecordStoreState,
  fieldName: RevisionScheduleListField,
  ...revisionSchedules: RevisionSchedule[]
) => {
  state.revisionSchedules.list(fieldName).set(...revisionSchedules);
};

export const pushRevisionSchedules = (
  state: RecordStoreState,
  fieldName: RevisionScheduleListField,
  ...revisionSchedules: RevisionSchedule[]
) => {
  state.revisionSchedules.list(fieldName).push(...revisionSchedules);
};

export const setRevisionScheduleCursor = (
  state: RecordStoreState,
  fieldName: RevisionScheduleListField,
  cursor: Cursor,
) => {
  state.revisionSchedules.list(fieldName).setCursor(cursor);
};
